module.exports = __webpack_public_path__ + "img/metal_ai@2x.5e69e6f2.png";